import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import * as QRCode from 'qrcode';
import { SalesQuotationCheckBoxes } from 'src/assets/static-data/SalesQuotationCheckBoxes';

@Component({
  selector: 'app-sales-quotation-pdf',
  standalone: true,
  imports: [SharedModule,CommonModule],
  templateUrl: './sales-quotation-pdf.component.html',
  styleUrl: './sales-quotation-pdf.component.scss'
})
export class SalesQuotationPdfComponent {
  @Input() orderData: any; // Accept data as input
  @Input() factories:any[];
  @Input() salesMen:any[];
  @Input() addressList:any[];

  qrCodeData = 'https://www.google.com/';
  baseUrl = window.location.origin; // Base URL
  qrCodeImage: string = '';
  selectedFactory:any;
  selectedSalesMan:any;
  salesQuotationCheckBoxes=SalesQuotationCheckBoxes;
  selectedAddresses=[];
  constructor(private el: ElementRef) {}

  

  ngOnChanges(){
    // // debugger;
    //console.log(this.orderData);
    this.selectedAddresses=[];
    this.selectedFactory=this.factories?.find(fact=>fact.id==this.orderData.factoryId);
    this.selectedSalesMan=this.salesMen?.find(sales=>sales.id==this.orderData.salesManId);
    this.qrCodeData=this.baseUrl+'/transactions/sales-quotation/view/'+this.orderData?.id;
    this.orderData?.customerAddressList?.forEach(add=>{
      this.selectedAddresses.push(this.addressList?.find(address=>address.id==add.id).name);
    })
    this.generateQRCode();
  }

  // Method to get the element (the part you want to use in html2pdf)
  getReportElement(): HTMLElement {
    // debugger
    return this.el.nativeElement.querySelector('#report-content'); // Assuming .report-content is the class for your report content
  }

  generateQRCode() {
    QRCode.toDataURL(this.qrCodeData, { width: 200 }, (err, url) => {
      if (err) {
        console.error('Error generating QR code:', err);
        return;
      }
      this.qrCodeImage = url;
    });
  }
}
